import { useParams } from "wouter";
import React, { Fragment, useContext, useEffect, useState } from 'react'
import { Menu, Popover, Transition } from '@headlessui/react'
import {
  AcademicCapIcon,
  BanknotesIcon,
  Bars3Icon,
  BellIcon,
  CheckBadgeIcon,
  ClockIcon,
  ReceiptRefundIcon,
  UsersIcon,
  XMarkIcon,
  DocumentIcon,
  DocumentChartBarIcon,
  PaperClipIcon
} from '@heroicons/react/24/outline'
import { AuthContext } from "../contexts/auth"
import { fetchEmployees } from '../services/api'
import { Link } from "wouter";
import ResourceHeader from "../components/resource_header";
import CuTable from "../components/cu_table";
import BusteTable from "../components/buste_table";
import BusteDetail from "../components/buste_detail";
import CuDetail from "../components/cu_detail";
import DocDetail from "../components/doc_detail";
import Navbar from "../components/navbar";
import BackButton from "../components/back_button";
import { useAtom } from "jotai";
import { currentPageStore } from "../stores/mainStore";



export default function ResourceDetail() {
  const { resourceType, resourceId } = useParams();

  const { profile, token } = useContext(AuthContext)

  const [currentPage, setCurrentPage] = useAtom(currentPageStore)

  useEffect(() => {
    if (resourceType) {
      setCurrentPage(resourceType)
    }
  }, [resourceType])


  return <>
    <div className="min-h-full">
      <Popover as="header" className='bg-ingigo-200'>
        <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:max-w-7xl lg:px-8">
          <div className="relative flex flex-wrap items-center justify-center lg:justify-between">
            <div className="w-full -5 lg:border-t lg:border-white lg:border-opacity-20">
              <div className="flex justify-center my-2 py-2">
                {resourceType === 'cu' && <h2 className="text-center text-2xl font-semibold text-indigo-800"></h2>}
                {resourceType === 'buste' && <h2 className="text-center text-2xl font-semibold text-indigo-800"></h2>}
                {resourceType === 'documenti' && <h2 className="text-center text-2xl font-semibold text-indigo-800"></h2>}
                {resourceType === 'dipendenti' && <h2 className="text-center text-2xl font-semibold text-indigo-800"></h2>}

              </div>
            </div>
          </div>
        </div>
      </Popover>
      <main className="mt-10 pb-8">
        <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:max-w-7xl lg:px-8">
          {/* back button */}
          <div className="flex items-center">
            <BackButton prevLocation={`/${resourceType}`} />
          </div>
          <div className="container mx-auto mt-6">
            {resourceType === 'cu' && <CuDetail loading={true} token={token} resourceId={resourceId}  />}
            {resourceType === 'buste' && <BusteDetail loading={true} token={token} resourceId={resourceId} />}
            {resourceType === 'documenti' && <DocDetail loading={true} token={token} resourceId={resourceId} />}
          </div>
        </div>
      </main>
      <footer>
        <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:max-w-7xl lg:px-8">
          <div className="border-t border-gray-200 py-8 text-center text-sm text-gray-500 sm:text-left">
            <span className="block sm:inline">&copy; {new Date().getFullYear()} Consultala SRL</span>{' '}
            <span className="block sm:inline">All rights reserved.</span>
          </div>
        </div>
      </footer>
    </div>
  </>;
}